import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, LeafIcon, LockKeyholeIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './Shared';
import { DecorativeDandelions } from './DecorativeDandelions';
const productImage = 'https://cdn.magicpatterns.com/uploads/4fvjTrMnTJYKdEuyTDHEyd/1nlnl.png';
export function Hero() {
  return <section className="relative isolate overflow-hidden border-b border-brand-green/15 py-8 sm:py-12 md:py-16 pt-[20px]" data-id="element-117" data-mp="4jvyzk2o7p0h">
      <DecorativeDandelions className="left-[4%] top-24 hidden h-64 w-48 md:block" data-id="element-118" data-mp="x9ur5oc5w29d" />
      <DecorativeDandelions className="bottom-4 right-[3%] hidden h-56 w-40 md:block" tone="gold" data-id="element-119" data-mp="sbb57nxkiqh0" />

      <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-120" data-mp="ncglmjrs0xvu">
        <motion.header initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} className="mx-auto flex max-w-4xl flex-col items-center" data-id="element-121" data-mp="nekkuoeqd8ps">
          <div className="inline-flex items-center gap-2 rounded-full border border-brand-green/25 bg-brand-cream px-4 py-2 text-xs font-bold tracking-[.14em] text-brand-dark shadow-sm" data-id="element-122" data-mp="3j895n7fl21mw">
            <LeafIcon className="h-4 w-4 text-brand-green" aria-hidden="true" data-id="element-123" data-mp="39aupl8xknev4" />
            LUMEN AKASHA™
          </div>

          <div className="hero-tagline mt-5 w-full px-1 text-center sm:mt-6" data-id="element-124" data-mp="3e8eh3aja5o50">
            <h1 className="hero-tagline-text mx-auto max-w-[18rem] font-[Cinzel,_serif] font-extrabold tracking-[.035em] sm:max-w-none text-[28px]" data-id="element-125" data-mp="30hho3ilfz4xf">
              ENTENDÉ EL ORIGEN.
              <br data-id="element-126" data-mp="2qjv4wjx40r7n" />
              TRANSFORMÁ TU CONSULTA.
            </h1>
          </div>

          <p className="max-w-2xl font-serif font-semibold text-brand-dark sm:text-xl md:text-2xl text-[13px] mt-[10px]" data-id="element-127" data-mp="2viy1rh2xrr4j">
            La herramienta clínica que faltaba en tu consultorio
          </p>
        </motion.header>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="mx-auto mt-6 w-full max-w-2xl sm:mt-8" data-id="element-128" data-mp="2lla5gmpombk9">
          <img src={productImage} alt="Colección Código Hepático con ebook, protocolos clínicos y guías para terapeutas" className="mx-auto max-w-[22rem] object-contain drop-shadow-[0_20px_22px_rgba(23,59,43,0.18)] sm:max-w-lg w-[324px] h-[324px]" draggable={false} data-id="element-129" data-mp="n98bzjimsxls" />
        </motion.div>

        <p className="mx-auto mt-5 max-w-2xl font-semibold text-brand-green sm:text-base text-[13px]" data-id="element-130" data-mp="1b04bz3x8qz44">
          El protocolo, las plantas y la hoja de ruta que tus pacientes
          necesitan para avanzar solos en 21 días.
        </p>

        <div className="mt-7 flex flex-col items-center gap-5 sm:mt-8" data-id="element-131" data-mp="x1eevoaf8zfr">
          <CTAButton className="max-w-full text-base md:text-lg" data-id="element-132" data-mp="x37b09nes19i">
            🌿 → QUIERO MI CODIGO AHORA
          </CTAButton>

          <div className="mx-auto w-full max-w-3xl overflow-hidden rounded-full border border-brand-green/15 bg-brand-cream/70" data-id="element-133" data-mp="3hrllakmueba1">
            <div className="ticker-track flex w-max items-center whitespace-nowrap py-2 text-xs font-medium text-brand-muted" data-id="element-134" data-mp="1xacf521xbhsp">
              {[0, 1].map(duplicate => <div key={duplicate} className="flex shrink-0 items-center gap-4 px-4" data-id="element-135" data-mp="269zivui4kzox">
                  <span className="inline-flex items-center gap-1.5" data-id="element-136" data-mp="26869i7g4o1d8">
                    <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-137" data-mp="2b2aiew8yejgy" />
                    Garantía 7 días
                  </span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-138" data-mp="2ky44b68kbpbe" />
                  <span data-id="element-139" data-mp="2ozz60bueo4pp">Descarga inmediata</span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-140" data-mp="2p1a3xv166i8w" />
                  <span data-id="element-141" data-mp="2tyshjyq4tln8">Listo para usar en consultorio</span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-142" data-mp="un9ajpoe2ng7" />
                  <span className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="zl12gjp1a9ke">
                    <LockKeyholeIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-144" data-mp="4bdxli20sdpo" />
                    Pago seguro
                  </span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-145" data-mp="3vh5jg58rl46o" />
                  <span className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="e91t4a7g9p8w">
                    <CreditCardIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-147" data-mp="9a7bvcp4s8qw" />
                    Mercado Pago
                  </span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-148" data-mp="3hnxwwrzjiyvu" />
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <div className="relative mt-9 border-y border-brand-green/15 bg-brand-cream/70 py-4 sm:mt-12" data-id="element-149" data-mp="3rhenzo8alzvt">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-5 gap-y-2 px-4 text-center text-xs text-brand-text sm:gap-x-6 sm:text-sm" data-id="element-150" data-mp="3mo2dsj4d1vml">
          <span data-id="element-151" data-mp="2tzmzxzwytjcu">
            <strong className="text-brand-green" data-id="element-152" data-mp="2u06iniufwbrx">+500</strong> terapeutas y
            personas acompañadas
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-brand-yellow sm:block" aria-hidden="true" data-id="element-153" data-mp="19gkksvdyntkc" />
          <span data-id="element-154" data-mp="1ebglejx9jp92">
            <strong className="text-brand-green" data-id="element-155" data-mp="zkhgbivmziu8">1</strong> ebook principal
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-brand-yellow sm:block" aria-hidden="true" data-id="element-156" data-mp="14jkdkh5dkkrn" />
          <span data-id="element-157" data-mp="1s959s1qjheiv">
            <strong className="text-brand-green" data-id="element-158" data-mp="1s8n5qixmxw0e">3</strong> bonus incluidos
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-brand-yellow sm:block" aria-hidden="true" data-id="element-159" data-mp="1x7zp2tpasky8" />
          <span className="inline-flex items-center gap-1" data-id="element-160" data-mp="1j8qk6q6jld9k">
            <StarIcon className="h-4 w-4 fill-brand-yellow text-brand-yellow" aria-hidden="true" data-id="element-161" data-mp="1j870b3xc0esw" />
            <strong className="text-brand-green" data-id="element-162" data-mp="1n88yh33uyq3f">4.9/5</strong> calificación
            promedio
          </span>
        </div>
      </div>
    </section>;
}